import * as React from 'react'
import { SVGProps } from 'react'

const SvgAvatar1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
      fill="#EAEAEA"
    />
    <mask
      id="avatar1_svg__a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <g mask="url(#avatar1_svg__a)">
      <path
        d="M50.553 17.021s4.931-.233 4.676 5.607c-.365 8.466-2.172 16.655-6.859 18.174-4.687 1.518-4.865-7.923-4.865-7.923l7.048-15.858Z"
        fill="#120284"
      />
      <path
        d="M51.428 17.708s.466-5.64-9.795-6.072c-10.262-.433-14.872 7.302-13.387 14.982 1.496 7.679 2.494 12.776 6.383 13.43 3.89.654 8.876-7.17 8.876-7.17l7.923-15.17Z"
        fill="#120284"
      />
      <path
        d="M53.844 54.82c-2.726 2.26-5.352 5.152-7.834 5.906h-.022c-8.19 2.46-14.716-3.457-17.254-5.585.188-.067.366-.144.554-.21.488-.2.953-.433 1.374-.688a11.025 11.025 0 0 0 2.094-1.65c4.1-4.123 3.192-9.985 3.192-9.985h11.491s-.221 2.006.044 4.61c.233 2.271.832 3.834 2.25 5.153.964.875 2.283 1.65 4.111 2.449Z"
        fill="#C4C4F7"
      />
      <path
        d="M47.495 47.218c-.676 1.152-1.64 1.961-3.004 2.072-5.352.443-8.366-4.81-8.3-5.297l.277-1.396H47.45s-.222 2.005.044 4.62Z"
        fill="#120284"
      />
      <path
        d="M54.697 32.546c0-1.496-1.063-2.715-2.371-2.715s-2.371 1.22-2.371 2.715c0 1.496 1.063 3.38 2.371 3.38s2.371-1.884 2.371-3.38Z"
        fill="#C4C4F7"
      />
      <path
        d="m51.717 33.477-.167-.022c0-.022.2-1.784 1.85-1.828v.166c-1.506.044-1.683 1.662-1.683 1.684Z"
        fill="#120284"
      />
      <path
        d="M53.334 33.222c-.277-.288-.565-.421-.853-.41-.432.022-.72.399-.731.399l-.133-.1c.01-.022.343-.443.853-.465.343-.022.665.133.986.465l-.122.111Z"
        fill="#120284"
      />
      <path
        d="M28.424 32.546c0-1.496 1.064-2.715 2.371-2.715 1.308 0 2.372 1.22 2.372 2.715 0 1.496-1.075 3.38-2.383 3.38-1.307 0-2.36-1.884-2.36-3.38Z"
        fill="#C4C4F7"
      />
      <path
        d="m31.67 33.477.166-.022c0-.022-.199-1.784-1.85-1.828v.166c1.496.044 1.684 1.662 1.684 1.684Z"
        fill="#120284"
      />
      <path
        d="M30.041 33.222c.277-.288.566-.421.854-.41.432.022.72.399.731.399l.133-.1c-.011-.022-.344-.443-.853-.465-.344-.022-.665.133-.987.465l.122.111Z"
        fill="#120284"
      />
      <path
        d="M48.326 42.974c-1.75 2.016-3.967 3.313-6.638 3.269-2.66.044-4.887-1.253-6.638-3.27a10.408 10.408 0 0 1-.033-.033c-3.136-3.967-3.779-9.751-2.925-16.633.61-4.953 5.285-6.87 7.879-7.557 1.13-.3 2.316-.3 3.446 0 2.593.687 7.258 2.604 7.879 7.557.842 6.893.2 12.7-2.97 16.667Z"
        fill="#C4C4F7"
      />
      <path
        d="M45.267 33.211a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13ZM37.743 33.211a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13ZM48.315 27.914s-1.363.056-3.158.067c-1.796.01-2.261-.011-2.095-.743.155-.731 1.962-.709 3.08-.465 1.12.255 2.173 1.141 2.173 1.141ZM34.574 27.914s1.363.056 3.158.067c1.795.01 2.26-.011 2.094-.743-.166-.731-1.961-.709-3.08-.465-1.12.255-2.172 1.141-2.172 1.141ZM41.311 36.646c-.2 0-.41-.033-.52-.133-.056-.044-.111-.144-.09-.288.078-.52.389-2.604.389-2.615l.166.022c0 .022-.31 2.094-.388 2.626-.011.078.011.111.033.133.155.144.698.089 1.009.022l.033.167c-.055 0-.344.066-.632.066ZM41.877 37.865c-.355 0-.599-.055-.61-.055-.055-.011-.078-.067-.067-.111.012-.055.067-.078.111-.066.089.022 2.106.454 3.147-1.452.023-.044.078-.067.122-.033.045.022.067.077.034.121-.732 1.375-1.984 1.596-2.737 1.596ZM43.162 38.264c-.045 0-.078-.033-.09-.077-.01-.056.023-.1.078-.111.145-.034.278-.078.4-.144a.106.106 0 0 1 .132.033c.023.044.011.1-.033.133a1.243 1.243 0 0 1-.454.166h-.033ZM50.664 23.304l.62 9.342.676-3.147s2.006-4.19-1.296-6.195ZM32.712 22.218l-.887 10.428-.42-3.147c.01 0-1.995-4.189 1.307-7.28Z"
        fill="#120284"
      />
      <path
        d="M51.195 26.972s-.775-1.718-2.914-5.275c0 0-9.386 6.283-16.832 3.823 0 0-1.098-2.914 1.905-5.463 3.004-2.548 6.095-4.321 10.561-2.87 4.466 1.452 8.51 5.552 7.28 9.785Z"
        fill="#120284"
      />
      <path
        d="M48.725 21.786s-.177 2.028 1.695 5.275c0 0-1.595-1.807-2.15-4.854 0 0-3.523 3.668-7.435 4.333 0 0 3.823-.543 7.336-5.153l.554.399Z"
        fill="#120284"
      />
      <path
        d="M82.301 97.516a1.333 1.333 0 0 0-.055.2H.22c-2.992-18.207 3.868-37.998 25-42.087a30.69 30.69 0 0 1 2.061-.333c.477-.066.964-.11 1.463-.155.088-.033.177-.066.277-.11.089-.034.177-.067.277-.112.488-.2.953-.432 1.374-.687a11.03 11.03 0 0 0 2.094-1.65c2.283 1.218 8.311 3.512 16.977-.211.953.886 2.272 1.65 4.1 2.449 0 0 .72.077 1.928.343.488.1 1.053.233 1.685.41h.01c7.47 2.028 24.025 9.198 25.698 32.967.244 3.325-.088 6.305-.864 8.976Z"
        fill="#E5994C"
      />
      <path
        d="M56.127 71.652c-.044.055-.078.122-.122.177-2.482 3.59-6.195 5.918-9.209 7.325a1.568 1.568 0 0 1-.2.089c-2.758 1.274-4.897 1.762-4.897 1.762a38.36 38.36 0 0 1-5.297-1.94c-.066-.033-.133-.066-.2-.088-4.354-2.04-7.191-4.588-9.008-7.292-.045-.055-.078-.122-.122-.177-2.616-4.011-2.97-8.344-2.627-11.768.011-.078.011-.144.023-.222.166-1.518.465-2.848.753-3.89a30.744 30.744 0 0 1 2.061-.332c.477-.066.964-.11 1.463-.155.177-.067.365-.144.543-.21.487-.2.953-.433 1.374-.688a11.03 11.03 0 0 0 2.094-1.65c2.283 1.218 8.311 3.512 16.977-.211.953.875 2.272 1.65 4.1 2.449 0 0 .72.077 1.928.343.488.1 1.053.244 1.685.41a25.003 25.003 0 0 1 1.02 3.945l.032.21c.82 4.976-.343 8.888-2.371 11.913Z"
        fill="#E5994C"
      />
      <path
        d="m41.754 63.63 14.362 8.022c-.044.055-.078.122-.122.177l-14.35-8.011 5.13 15.336c-.066.033-.133.067-.2.089l-5.13-15.326-5.075 15.137a1.568 1.568 0 0 0-.2-.088l5.076-15.16-14.085 7.868c-.044-.055-.077-.122-.122-.177l14.096-7.868-16.722-3.9c.011-.078.011-.145.022-.222l17 3.967 17.02-3.967.033.21-16.733 3.912Z"
        fill="#5661E2"
      />
      <path
        d="M41.688 76.827c-19.99-7.668-12.954-21.686-12.954-21.686.177-.067.365-.144.543-.21a9.95 9.95 0 0 0 1.374-.688 11.031 11.031 0 0 0 2.094-1.65c2.283 1.218 8.311 3.512 16.977-.211.953.875 2.272 1.65 4.1 2.449 7.003 15.004-12.134 21.996-12.134 21.996Z"
        fill="#fff"
      />
      <path
        d="M82.301 97.516c.809-33.898-24.445-41.821-24.833-41.943 7.469 2.028 24.035 9.186 25.709 32.967.232 3.324-.1 6.305-.876 8.976Z"
        fill="#120284"
      />
      <path
        d="M41.2 59.607c-1.595 0-3.036-.189-4.266-.444-4.067-.842-6.748-2.626-6.77-2.648l.121-.177c.023.022 2.682 1.773 6.705 2.615 3.712.775 9.374.897 15.325-2.893l.122.189c-4.056 2.57-7.967 3.358-11.236 3.358Z"
        fill="#C4C4F7"
      />
    </g>
  </svg>
)

export default SvgAvatar1
